<template>
  <el-dialog title="配置等级" :visible.sync="dialogVisible" width="650px">
    <div v-if="loading" class="loading-wrapper">
      <el-icon class="is-loading"><loading /></el-icon>
      加载中...
    </div>
    <div class="level-selection">
      <el-checkbox-group v-model="selectedLevels">
        <el-checkbox v-for="level in levels" :key="level.value" :label="level.value" class="level-checkbox">
          {{ level.label }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <div v-if="selectedLevels.length > 0" class="level-edit-section">
      <div class="custom-tip">自定义等级名称：</div>
      <div class="level-edit-grid">
        <div v-for="level in visibleLevels" :key="level.value" class="level-edit-item">
          <span class="level-label">{{ getOriginalLabel(level.value) }}：</span>
          <el-input
            v-model="level.customLabel"
            :placeholder="`请输入${getOriginalLabel(level.value)}名称`"
            clearable
            class="level-input"
          ></el-input>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSave">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { submit } from '@/api/base'
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      selectedLevels: [],
      levels: [
        { value: 'level1', label: '一级', customLabel: '' },
        { value: 'level2', label: '二级', customLabel: '' },
        { value: 'level3', label: '三级', customLabel: '' },
        { value: 'level4', label: '四级', customLabel: '' },
        { value: 'level5', label: '五级', customLabel: '' },
        { value: 'level6', label: '六级', customLabel: '' },
      ],
      selectedPurchasers: [],
    }
  },
  computed: {
    visibleLevels() {
      return this.levels.filter(level => this.selectedLevels.includes(level.value))
    },
  },
  methods: {
    async open(purchasers) {
      this.selectedPurchasers = purchasers
      this.dialogVisible = true
      this.loading = true
      try {
        const response = await submit('/api/common/getCustomerParameter?key=PurchaserLevels')

        if (response.success && response.data) {
          const savedLevels = JSON.parse(response.data)
          this.selectedLevels = Object.keys(savedLevels)
          this.levels.forEach(level => {
            if (savedLevels[level.value]) {
              level.customLabel = savedLevels[level.value]
            }
          })
        }
      } catch (error) {
        console.error('获取等级配置失败:', error)
        this.$message.error('获取等级配置失败，请重试')
      } finally {
        this.loading = false
      }
    },

    getOriginalLabel(value) {
      const level = this.levels.find(l => l.value === value)
      return level ? level.label : ''
    },

    handleSave() {
      if (this.selectedLevels.length === 0) {
        this.$message.warning('请至少选择一个等级')
        return
      }

      this.$emit('handleSaveLevels', {
        levels: this.selectedLevels,
        levelNames: this.levels.reduce((acc, level) => {
          if (this.selectedLevels.includes(level.value)) {
            acc[level.value] = level.customLabel || level.label
          }
          return acc
        }, {}),
      })
      this.dialogVisible = false
    },
  },
}
</script>

<style scoped>
.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  color: #666;
}

.loading-wrapper .el-icon {
  margin-right: 8px;
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.level-selection {
  margin-bottom: 15px;
}

.level-checkbox {
  margin-right: 20px;
}

.level-edit-section {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.custom-tip {
  color: #888;
  font-size: 14px;
  margin-bottom: 15px;
}

.level-edit-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.level-edit-item {
  display: flex;
  align-items: center;
}

.level-label {
  width: 60px;
  text-align: right;
  padding-right: 10px;
}

.level-input {
  flex: 1;
}

.dialog-footer {
  text-align: right;
}
</style>
